<template>
  <div style="height: 500px">
    <a-list :loading="loading">
      <div slot="header" style="padding-top: 20px">
        <span class="titleClass">界面配置</span>
        <br/><br/>
        <span>页面布局/组件设置</span>
      </div>
      <a-list-item style="padding: 20px">
        <div style="width: 100%">
          <a-row :gutter="[16,24]">
            <a-col :span="8">
              <span>隐藏顶部导航</span>
            </a-col>
            <a-col :span="8" :offset="8">
              <a-switch :checked="interfaceConfig.hideTopMenu === 1" style="position: absolute;right: 5px"
                        @change="switchChange('hideTopMenu')">
                <a-icon slot="checkedChildren" type="check"/>
                <a-icon slot="unCheckedChildren" type="close"/>
              </a-switch>
            </a-col>
          </a-row>
<!--          <a-row :gutter="[16,24]">-->
<!--            <a-col :span="8">-->
<!--              <span>隐藏侧边导航</span>-->
<!--            </a-col>-->
<!--            <a-col :span="8" :offset="8">-->
<!--              <a-switch :checked="interfaceConfig.hideSideMenu === 1" style="position: absolute;right: 5px"-->
<!--                        @change="switchChange('hideSideMenu')">-->
<!--                <a-icon slot="checkedChildren" type="check"/>-->
<!--                <a-icon slot="unCheckedChildren" type="close"/>-->
<!--              </a-switch>-->
<!--            </a-col>-->
<!--          </a-row>-->
        </div>
      </a-list-item>
      <a-list-item style="padding: 20px">
        <div style="width: 100%">
          <a-row :gutter="[16,24]">
            <a-col :span="8">
              <span>隐藏音乐播放器</span>
            </a-col>
            <a-col :span="8" :offset="8">
              <a-switch :checked="interfaceConfig.hideMusicPlayer === 1" style="position: absolute;right: 5px"
                        @change="switchChange('hideMusicPlayer')">
                <a-icon slot="checkedChildren" type="check"/>
                <a-icon slot="unCheckedChildren" type="close"/>
              </a-switch>
            </a-col>
          </a-row>
          <a-row :gutter="[16,24]">
            <a-col :span="8">
              <span>隐藏猫猫</span>
            </a-col>
            <a-col :span="8" :offset="8">
              <a-switch :checked="interfaceConfig.hideKanbanAssistant === 1" style="position: absolute;right: 5px"
                        @change="switchChange('hideKanbanAssistant')">
                <a-icon slot="checkedChildren" type="check"/>
                <a-icon slot="unCheckedChildren" type="close"/>
              </a-switch>
            </a-col>
          </a-row>
        </div>
      </a-list-item>
    </a-list>
    <div class="button-style">
      <a-button :style="{ marginRight: '8px' }" @click="onCancel">
        取消
      </a-button>
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import UserConfigurationRequest from "@/store/RequestModules/UserConfigurationRequest";
import SystemUserRequest from "@/store/RequestModules/SystemUserRequest";

export default {
  name: "InterfaceConfiguration",
  data() {
    return {
      loading: false,
      interfaceConfig: {
        hideTopMenu: null,
        hideSideMenu: null,
        hideMusicPlayer: null,
        hideKanbanAssistant: null,
      },
    };
  },
  methods: {
    onCancel() {
      this.interfaceConfig = _.cloneDeep(this.$store.state.userInfo);
    },
    switchChange(key) {
      this.interfaceConfig[key] = this.interfaceConfig[key] === 0 ? 1 : 0
    },
    onSubmit() {
      this.loading = true
      UserConfigurationRequest.updateUserConfiguration(this.interfaceConfig).then(res => {
        if (res.status == '200') {
          SystemUserRequest.info().then(res => {
            const userInfo = res.data.data;
            this.$store.commit("SET_USERINFO", userInfo);
            this.imageUrl = userInfo.avatar
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    this.interfaceConfig = _.cloneDeep(this.$store.state.userInfo);
  }
}
</script>

<style scoped>
.titleClass {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}

.button-style {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>